export const MIX_PHASES = Object.freeze({
  IDLE: 'idle',
  PLAYING: 'playing',
  EXPLAINED: 'explained',
});
